import React from "react";
import DropdownArrow from "../../../assets/img/icons/dropdownarrow.svg";

const DropDownArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} alt="Down Arrow" />
  </div>
);

export default DropDownArrowIcon;
